import { Component, Prop, ComponentInterface } from "@stencil/core";
import { init, AmplitudeInitArgs } from "./amplitude";

@Component({
  tag: "bc-amplitude",
  shadow: true,
})
export class BcAmplitude implements ComponentInterface {
  @Prop() amplitudeApiKey!: string;
  @Prop() amplitudeUserId?: string;
  @Prop() accountPlanName?: string;
  @Prop() accountCreatedAt?: string;
  @Prop() accountEmail?: string;
  @Prop() accountStatus?: string;
  offLocationChange?: () => void;

  async componentWillLoad() {
    var amplitudeArgs: AmplitudeInitArgs = {
      amplitudeApiKey: this.amplitudeApiKey,
      amplitudeUserId: this.amplitudeUserId,
    };

    if (
      this.accountPlanName &&
      this.accountCreatedAt &&
      this.accountEmail &&
      this.accountStatus
    ) {
      amplitudeArgs.user = {
        planName: this.accountPlanName,
        createdAt: this.accountCreatedAt,
        email: this.accountEmail,
        status: this.accountStatus,
      };
    }

    this.offLocationChange = await init(amplitudeArgs);
  }

  disconnectedCallback() {
    if (this.offLocationChange) this.offLocationChange();
  }
}
